module.exports = __webpack_public_path__ + "img/icon_excel.082fa1ae.png";